import * as React from "react";
import cn from "classnames";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import Reviews from "../../components/reviews";
import Hero from "./components/hero";
import Banner from "./components/banner";
import Steps from "./components/steps";
import WhatsIncluded from "./components/whats-included";
import MoneyBack from "./components/money-back";
import QA from "./components/q-a";
import Cta from "./components/cta";
import Footer from "../../components/footer";
import Button from "../../components/button";
import styles from "./start.module.scss";
import OgContent from "../../components/og-content";
import Shipping from "./components/shipping";

const Start = () => {
  const [showButton, toggleButton] = React.useState();
  const [invertButton, setInvertButton] = React.useState();
  const [closing, setClosing] = React.useState();

  useScrollPosition(data => {
    if (data.currPos.y < -1 * window.innerHeight + 320) {
      toggleButton(true);
    } else if (showButton) {
      setClosing(true);
      setTimeout(() => {
        setClosing(false);
        toggleButton(false);
      }, 200);
    }

    const element = document.getElementById("money-back");

    if (element) {
      let bodyRect = document.body.getBoundingClientRect(),
        elemRect = element.getBoundingClientRect(),
        offset = elemRect.top - bodyRect.top;

      const reachedPosition = data.currPos.y < -1 * (offset - elemRect.height);
      const passedPosition = data.currPos.y < -1 * offset;

      if (reachedPosition && !passedPosition) {
        setInvertButton(true);
      } else if (invertButton) {
        setInvertButton(false);
      }
    }
  });

  return (
    <>
      <OgContent />

      <div>
        {showButton && (
          <a href="/cart">
            <Button
              variant={invertButton ? "invert" : "cta"}
              showEmojiAnyWay={invertButton}
              className={cn(
                styles.fixedCartButton,
                closing && styles.fixedCartButtonClosing
              )}
            >
              RUSH MY ORDER
            </Button>
          </a>
        )}
        <Hero />
        <Banner />
        <Steps />
        <WhatsIncluded />
        <MoneyBack />
        <Reviews />
        <QA />
        <Shipping />
        <Cta />
        <Footer />
      </div>
    </>
  );
};

export default Start;
